// src/redux/slices/profileSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiEncryptDecrypt from "../../Utils/Encryption";
import axiosInstance from "../../Utils/axiosInstance";

const Key = import.meta.env.VITE_Encryption_Decryption_Key;
export const fetchProfileDetails = createAsyncThunk(
  "profile/fetchProfileDetails",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const getLoggedInUser = JSON.parse(
        sessionStorage.getItem("loggedInUser")
      );
      if (!getLoggedInUser) return rejectWithValue("User not logged in");

      const data = {
        AppVersion: getLoggedInUser?.AppVersion,
        LoginToken: getLoggedInUser?.LoginToken,
        AutoId: getLoggedInUser?.AutoID,
      };

      const encryptedData = await ApiEncryptDecrypt.encryptString(
        Key,
        JSON.stringify(data)
      );
      const res = await axiosInstance.post("/GetProfileDetails", {
        Body: encryptedData,
      });

      const decryptedRes = await ApiEncryptDecrypt.decryptString(
        Key,
        res.data.body
      );
      const obj = JSON.parse(decryptedRes);

      if (obj.Status === 3) {
        dispatch(uiAction.updateAppType("Business"));
        sessionStorage.clear();
        return rejectWithValue("Session expired");
      }
      return obj.Response;
    } catch (error) {
      return rejectWithValue(error?.message || "Unknown error");
    }
  }
);
// profileSlice.js
export const updateAddressDetails = createAsyncThunk(
  "profile/updateAddressDetails",
  async (addressPayload, { dispatch, rejectWithValue }) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("loggedInUser"));
      if (!user) return rejectWithValue("User not logged in");
      const payload = {
        AutoId: user.AutoID,
        LoginToken: user.LoginToken,
        AppVersion: user.AppVersion,
        DeviceType: "Web",
        AssoCode: user.AssociateCode,
        ...addressPayload,
      };

      const encryptedData = await ApiEncryptDecrypt.encryptString(
        Key,
        JSON.stringify(payload)
      );
      // console.log(encryptedData)
      const response = await axiosInstance.post(
        "/UpdateProfilePCAddressDetails",
        {
          Body: encryptedData,
        }
      );

      const decryptedRes = await ApiEncryptDecrypt.decryptString(
        Key,
        response.data.body
      );
      const result = JSON.parse(decryptedRes);
      //   console.log(result);
      if (result.Status === 3) {
        sessionStorage.clear();
        dispatch(uiAction.updateAppType("Business"));
        return rejectWithValue("Session expired");
      }
      if (result.Status !== 0) {
        return rejectWithValue(result.Message || "Update failed");
      }
      return result;
    } catch (err) {
      return rejectWithValue(err?.message || "Something went wrong");
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearProfile: (state) => {
      state.profileDetails = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfileDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.profileDetails = action.payload;
      })
      .addCase(fetchProfileDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateAddressDetails.fulfilled, (state, action) => {
        // Optionally show a success state or toast here
      });
  },
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
